import React, {forwardRef, useImperativeHandle, useState} from "react";
import {Modal, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {imgPathPerfix} from "@/utils";
import {MAX_Z_INDEX} from "@/Const";

let mDirection:any;
const DialogProgress = forwardRef((props, ref)=>{
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onUpdateProgress:onUpdateProgress,
        onFinished:onFinished,
        onCloseDialog:onCloseDialog
    }));
    const [isShowDialog,setIsShowDialog] = useState(false);
    const [progressTips,setProgressTips] = useState('');
    const [isFinished,setIsFinished] = useState(false);
    const [isMaskClose,setIsMaskClose] = useState(true);

    const onShowDialog = (tips:string,direction='row',bMaskClose = true)=>{
        mDirection = direction;
        setProgressTips(tips);
        setIsFinished(false);
        setIsShowDialog(true);
        setIsMaskClose(bMaskClose);
    }

    const onUpdateProgress = (tips:string)=>{
        setProgressTips(tips);
    }

    const onFinished = (tips:string)=>{
        setIsFinished(true);
        setProgressTips(tips);
        setTimeout(()=>{
            setIsShowDialog(false);
        },1600)
    }

    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }

    return(
        <Modal zIndex={MAX_Z_INDEX} maskClosable={isMaskClose} closable={false} open={isShowDialog} onCancel={(e)=> {
            setIsShowDialog(false);
            if (window.onCloseProgressCallback) {
                window.onCloseProgressCallback();
            }
        }} centered={true} footer={null}
               width={468} bodyStyle={{margin:'-20px -20px'}}>
            <div className={mDirection=='row'?'flex-center':'flex-column-center'} style={{height:'195px'}}>
                {
                    isFinished?<img className={'img-36'} src={imgPathPerfix()+'finished.png'}/>:<Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}/>
                }
                <span className={(mDirection == 'row'?'':'mt-12')+' ml-12'}>{progressTips}</span>
            </div>
        </Modal>
    )
})

export default DialogProgress;